import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NationalTeamsService} from '../../services/national-teams.service';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ChangeNationalTeamDialogComponent} from '../dialogs/change-national-team-dialog/change-national-team-dialog.component';
import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'app-switch-national-team',
  templateUrl: './switch-national-team.component.html',
  styleUrls: ['./switch-national-team.component.scss']
})
export class SwitchNationalTeamComponent implements OnInit {
  @Output() onSwitchNationalTeamClose: EventEmitter<any> = new EventEmitter();

  constructor(
      public nationalTeamsService: NationalTeamsService,
      public modalService: NgbModal,
      private angulartics2: Angulartics2) { }

  ngOnInit() {
  }

  openChangeNationalTeamModal() {
    this.modalService.open(ChangeNationalTeamDialogComponent);
  }

  onNationalTeamSelect(nationalTeam) {
    this.onSwitchNationalTeamClose.emit();
    this.nationalTeamsService.setNationalTeam(nationalTeam);
    this.angulartics2.eventTrack.next({
      action: 'Switch Team',
      properties: {
        category: 'Header',
        label: nationalTeam.name,
      }
    });
  }

}
